module.exports = __webpack_public_path__ + "static/media/welcome-min.e6180cfb.jpg";